'use strict';

var Marionette = require('backbone.marionette');
var polyglot = require('../../utilities/polyglot').default;
var LanguageCollection = require('../../collections/languages').default;
var AppointmentCollection = require('../../collections/appointments').default;

export default Marionette.View.extend({

  className: 'appointments-no-appointment-view',
  template: require('./templates/no-appointments.hbs'),

  initialize: function(options) {
    this.message = options.message ? options.message : polyglot.t('cancel.no_appointments');
  },

  serializeData: function() {
    this.collection = new AppointmentCollection(window.APPOINTMENTS);
    this.model = this.collection.first();
    const json = this.model ? this.model.toJSON() : {};

    return {
      bookLink: this.getBookingLink(json),
      emptyMsg: this.message,
    };
  },

  /**
   * Link back to the start of the client view.
   *
   * @returns {string}
   */
  getBookingLink: function (json) {
    const lang = new LanguageCollection(window.LANGUAGES).getCurrent();
    let link = `${window.location.pathname}?lang=${lang}`;

    const hasBookingShortcut = Object.keys(json).length
                               && json.appointmentclient[0].booking_shortcut;
    if (hasBookingShortcut && window.SETTINGS.use_booking_context) {
      link += `&${json.appointmentclient[0].booking_shortcut}`;
    }

    return link;
  },

  focus: function() {},

});
